import { render, staticRenderFns } from "./goodsEvaluationView.vue?vue&type=template&id=9b428b98&scoped=true"
import script from "./goodsEvaluationView.vue?vue&type=script&lang=js"
export * from "./goodsEvaluationView.vue?vue&type=script&lang=js"
import style0 from "./goodsEvaluationView.vue?vue&type=style&index=0&id=9b428b98&prod&lang=scss&scoped=true"
import style1 from "./goodsEvaluationView.vue?vue&type=style&index=1&id=9b428b98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b428b98",
  null
  
)

export default component.exports